import React from 'react'
import styled from 'styled-components'
import {Paragraph} from '../../texts'
import {Image} from '../../images'
import {CardTreeInfoProps} from './CardTreeInfoProps'

const StyledContainer = styled.div`
  ${({theme}) => ({
    backgroundColor: theme.white_4,
    borderColor: theme.gray_1,
  })}
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  width: 100%;
  padding: 20px;
  border-style: solid;
  border-radius: 16px;
  border-width: 2px;
  gap: 20px;
`

const StyledHeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 20px;
`

const StyledImage = styled(Image)`
  height: 80px;
  width: 80px;
  border-radius: 8px;
  object-fit: cover;
`

const StyledDescription = styled(Paragraph)`
  line-height: 21px;
  text-align: justify;
`

export default function CardTreeInfo({
  url,
  name,
  description,
}: CardTreeInfoProps) {
  return (
    <StyledContainer>
      <StyledHeaderContainer>
        <StyledImage src={url} alt={`Image ${name}`} />
        <Paragraph fontSize="l" fontWeight="bold">
          {name}
        </Paragraph>
      </StyledHeaderContainer>
      <StyledDescription>{description}</StyledDescription>
    </StyledContainer>
  )
}
